import { useMeNullableQuery } from "@gql-schema";

export function useMeNullable() {
    const { data } = useMeNullableQuery();

    return data?.meNullable ?? null;
}
